let configure = null;

export const setConfig = (newConfig) => {
  configure = newConfig;
};

export const getConfig = () => {
  if (!configure) {
    throw new Error("Config aún no cargada");
  }
  return configure;
};

